import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function login (data) {
  apiConsolelog('api: login()')

  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function logout () {
  apiConsolelog('api: logout()')

  return request({
    url: '/auth/logout',
    method: 'post'
  })
}
